import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import organisationService from '../../services/organisationService';
import '../../pages/ApplicantPages.css';

// A prompt on the dashboard when someone has invited this person to join an organisation.
const PendingInvitations = () => {
  const [invitations, setInvitations] = useState([]);

  useEffect(() => {
    organisationService.myInvitations().then(setInvitations).catch(() => {});
  }, []);

  if (invitations.length === 0) return null;

  return (
    <div className="ap-card" role="status">
      <h2>You have been invited</h2>
      <p>
        {invitations.length === 1
          ? `${invitations[0].organisation_name} has invited you to join their team.`
          : `${invitations.length} organisations have invited you to join their teams.`}
      </p>
      <Link to="/organisation-invitations" className="btn-primary ap-button">Review invitations</Link>
    </div>
  );
};

export default PendingInvitations;
